import logger from "../utils/logger"


export const phoneNumberFormat = (number, prefix, isTitle = false) => {

  logger.debug('phoneNumberFormat: ', number, prefix)

  const cleanedNumber = String(number).replace(/\D/g, '')

  const cleanedPrefix = String(prefix).replace(/\D/g, '')

  if (isTitle) {
    const newNumber = `+${cleanedPrefix}-${cleanedNumber}`

    return newNumber

  } else {
    const newNumber = `+${cleanedPrefix}${cleanedNumber}`

    return newNumber
  }


}

